exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".faq{margin-top:5px;margin-bottom:5px;font-size:1.17em}", ""]);

// exports
